import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaLightbulb, FaRocket, FaThumbsUp, FaComments, FaSmileBeam } from 'react-icons/fa';
import '../styles/Methodology.css';

// Icons / colours per step; the texts live in the locale files (methodology.steps)
const STEP_META = [
  // color: the decorative dot. text: the same hue, dark enough for AA as title text.
  { icon: <FaLightbulb />, color: "#ffca28", text: "#8a6200" },
  { icon: <FaRocket />, color: "#42a5f5", text: "#1565c0", highlight: true },
  { icon: <FaThumbsUp />, color: "#66bb6a", text: "#2e7d32" },
  { icon: <FaComments />, color: "#ab47bc", text: "#7b1fa2" },
  { icon: <FaSmileBeam />, color: "#ffa726", text: "#a85200" }
];

const Methodology = () => {
  const { t } = useTranslation();
  const steps = t('methodology.steps').map((step, i) => ({ ...step, ...STEP_META[i] }));

  return (
    <section className="methodology-section py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="display-4 font-weight-bold">{t('methodology.title')}</h2>
          <p className="lead text-muted">{t('methodology.subtitle')}</p>
        </div>

        <div className="timeline-container">
          {steps.map((step, index) => (
            <div key={index} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
              <div className="timeline-dot" style={{ backgroundColor: step.color }}>
                {step.icon}
              </div>
              <div className={`timeline-content ${step.highlight ? 'highlight-card' : ''}`}>
                <h4 style={{ color: step.text }}>{step.title}</h4>
                <p>{step.description}</p>
                {step.highlight && <span className="free-badge">{t('methodology.free')}</span>}
              </div>
            </div>
          ))}
          <div className="timeline-line"></div>
        </div>
      </div>
    </section>
  );
};

export default Methodology;
